// removed by extract-text-webpack-plugin
module.exports = {"button":"CreateAccountForm__button___2Bz5p"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/register/CreateAccountForm.css
// module id = 1183
// module chunks = 0